<div class="flex flex-col gap-4" animate.enter="anim-fade-from-bottom">
  <!-- Row 1: Short vowels, Long vowels, Space -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key)"
        />
      }
    </rid-key-group>
    <rid-key-group>
      <rid-keyboard-key
        [key]="convertValueToKey('▭')"
        [hidden]="isHidden('▭')"
        [hasHighlight]="hasHighlight('▭')"
        [disabled]="!isEnabled('▭')"
        (pressed)="type(convertValueToKey('▭'))"
      />
      @for (pair of doubleVowelKeys; track $index) {
        @let longKey = pair[0];
        @let shortKey = pair[1];
        <rid-long-vowel-key-wrapper
          [class.hidden]="isHidden(longKey.value) && isHidden(shortKey.value)"
          [disabled]="!isEnabled(longKey.value) && !isEnabled(shortKey.value)"
        >
          <rid-keyboard-key
            [key]="longKey"
            [hidden]="isHidden(longKey.value)"
            [hasHighlight]="hasHighlight(longKey.value)"
            [disabled]="!isEnabled(longKey.value)"
            (pressed)="type(longKey)"
          />
          <rid-keyboard-key
            [key]="shortKey"
            [hidden]="isHidden(shortKey.value)"
            [hasHighlight]="hasHighlight(shortKey.value)"
            [disabled]="!isEnabled(shortKey.value)"
            (pressed)="type(shortKey)"
          />
        </rid-long-vowel-key-wrapper>
      }
    </rid-key-group>
    <rid-key-group>
      @for (key of keyboardKeyGroups['SPACE']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 2: Two-letter phonemes -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['DUBBELE_KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 3: Three-letter and Four-letter phonemes -->
  <rid-keyboard-row>
    <rid-key-group>
      @for (key of keyboardKeyGroups['DRIEDUBBELE_KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key)"
        />
      }
    </rid-key-group>
    <rid-key-group>
      @for (key of keyboardKeyGroups['VIERDUBBELE_KLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 4: Consonants -->
  <rid-keyboard-row>
    <rid-key-group lpWizardTarget="keyboard.medeklinkers">
      @for (key of keyboardKeyGroups['MEDEKLINKERS']; track key) {
        <rid-keyboard-key
          [key]="key"
          [hidden]="isHidden(key.value)"
          [hasHighlight]="hasHighlight(key.value)"
          [disabled]="!isEnabled(key.value)"
          (pressed)="type(key)"
        />
      }
    </rid-key-group>
  </rid-keyboard-row>

  <!-- Row 5: Specials -->
  <div class="relative mx-auto w-fit">
    <rid-keyboard-row>
      <rid-key-group>
        @for (key of keyboardKeyGroups['EXOTEN']; track key) {
          <rid-keyboard-key
            [key]="key"
            [hidden]="isHidden(key.value)"
            [hasHighlight]="hasHighlight(key.value)"
            [disabled]="!isEnabled(key.value)"
            (pressed)="type(key)"
          />
        }
      </rid-key-group>
      <rid-key-group>
        @for (key of keyboardKeyGroups['SJWAS']; track key) {
          <rid-keyboard-key
            [key]="key"
            [hidden]="isHidden(key.value)"
            [hasHighlight]="hasHighlight(key.value)"
            [disabled]="!isEnabled(key.value)"
            (pressed)="type(key)"
          />
        }
      </rid-key-group>
      <rid-key-group>
        @for (key of keyboardKeyGroups['KLANKVOET']; track key) {
          <rid-keyboard-key
            [key]="key"
            [hidden]="isHidden(key.value)"
            [hasHighlight]="hasHighlight(key.value)"
            [disabled]="!isEnabled(key.value)"
            (pressed)="type(key)"
          />
        }
      </rid-key-group>
      <rid-key-group lpWizardTarget="keyboard.rule">
        @for (key of keyboardKeyGroups['RULE']; track key) {
          <rid-keyboard-key
            [key]="key"
            [hidden]="isHidden(key.value)"
            [hasHighlight]="hasHighlight(key.value)"
            [disabled]="!isEnabled(key.value)"
            (pressed)="type(key)"
          />
        }
      </rid-key-group>
    </rid-keyboard-row>

    @if (contextualKeys().length > 0) {
      <rid-key-group class="absolute top-1/2 left-full z-10 ml-4 -translate-y-1/2" animate.enter="anim-pop-in" ridSfx="BUBBLE_POP">
        @for (key of contextualKeys(); track key.value) {
          <rid-keyboard-key
            [key]="key"
            [hidden]="isHidden(key.value)"
            [hasHighlight]="hasHighlight(key.value)"
            [disabled]="!isEnabled(key.value)"
            [animateEnter]="false"
            (pressed)="type(key)"
          />
        }
      </rid-key-group>
    }
  </div>
</div>
